import { Lock } from 'lucide-react';
import useModules from '@/shared/auth/useModules';

/**
 * Enveloppe un écran qui appartient à un module commercial.
 *
 * Sans elle, un sous-compte qui n'a pas souscrit le module atteignait quand même la page
 * — par une URL, un favori, un retour arrière — et lisait « 0 résultat, aucun actif ne
 * correspond aux filtres ». L'API refusait pourtant : l'écran traduisait un refus en
 * parc vide, ce qui est la pire des deux erreurs possibles. Un exploitant en conclut
 * qu'il n'a rien installé.
 *
 * Ce n'est pas une protection — elle est côté serveur, sur le chemin de chaque requête.
 * C'est une explication.
 */
export default function ModuleRequis({ module, children }) {
  const { souscrit, pret } = useModules();

  // Tant qu'on ne sait pas, on n'affirme rien : ni l'écran, ni le refus.
  if (!pret) return null;
  if (souscrit(module)) return children;

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6" data-testid="module-non-souscrit">
      <div className="max-w-md text-center">
        <div className="w-12 h-12 rounded-full bg-neutral-100 flex items-center justify-center mx-auto mb-4">
          <Lock className="w-5 h-5 text-neutral-500" />
        </div>
        <h1 className="text-lg font-semibold text-neutral-900">
          Le module « {module} » n&apos;est pas souscrit
        </h1>
        <p className="text-[13px] text-neutral-500 mt-2">
          Cet écran fait partie d&apos;un module que votre sous-compte n&apos;a pas activé.
          Vos données ne sont pas perdues : elles ne sont simplement pas accessibles depuis
          ici. Rapprochez-vous de votre gestionnaire de compte pour l&apos;activer.
        </p>
      </div>
    </div>
  );
}
